export default __webpack_public_path__ + "static/media/Bigger-logo.6708723f.png";